import React, { useEffect } from 'react';
import { useToast } from '../hooks/useToast';
import websocketService from '../services/websocketService';
import toastService from '../services/toastService';
import { useAuth } from '../contexts/AuthContextNew';
import { formatCurrency } from '../utils/countryUtils';

const GlobalToast = () => {
  const { ToastComponent, showToast } = useToast();
  const { user, isAuthenticated } = useAuth();

  // Register this component's showToast function with the global service
  useEffect(() => {
    toastService.registerHandler(showToast);
    
    return () => {
      toastService.unregisterHandler(showToast);
    };
  }, [showToast]);

  useEffect(() => {
    if (!isAuthenticated || !user?.id) return;

    // Connect to WebSocket for real-time notifications
    const token = localStorage.getItem('customerToken') || localStorage.getItem('token');
    if (token) {
      websocketService.connect(token);
    }

    // Listen for toast notifications from backend (using notification templates)
    const handleToastNotification = (toastData) => {
      showToast(
        toastData.message,
        toastData.type || 'success',
        toastData.duration || 6000
      );
    };

    // Listen for real-time notifications
    const handleNewNotification = (notificationData) => {
      // Toast will be handled by the notification system
    };

    // Listen for order confirmations
    const handleOrderConfirmation = (orderData) => {
      showToast(
        `🎉 Order ${orderData.orderNumber} confirmed! Total: ${formatCurrency(orderData.totalAmount || 0)}`,
        'success',
        6000
      );
    };

    // Listen for booking confirmations  
    const handleBookingConfirmation = (bookingData) => {
      showToast(
        `📅 Booking ${bookingData.bookingNumber} confirmed!`,
        'success',
        6000
      );
    };

    // Setup WebSocket listeners
    websocketService.on('toast_notification', handleToastNotification);
    websocketService.on('new_notification', handleNewNotification);
    websocketService.on('order_confirmation', handleOrderConfirmation);
    websocketService.on('booking_confirmation', handleBookingConfirmation);

    // Cleanup listeners
    return () => {
      websocketService.off('toast_notification', handleToastNotification);
      websocketService.off('new_notification', handleNewNotification);
      websocketService.off('order_confirmation', handleOrderConfirmation);
      websocketService.off('booking_confirmation', handleBookingConfirmation);
    };
  }, [isAuthenticated, user?.id]);


  return (
    <>
      <ToastComponent />
      
    </>
  );
};

export default GlobalToast;
